import { render, staticRenderFns } from "./BarChartRevote.vue?vue&type=template&id=6089bfae"
import script from "./BarChartRevote.vue?vue&type=script&lang=js"
export * from "./BarChartRevote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports